/* eslint-disable no-undef */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

interface ErrorResponse {
  error: string;
  message: string;
  statusCode: number;
  data?: any;
}

interface ErrorOptions {
  [key: string]: any;
}

const makeError = (err: any, options: ErrorOptions = {}): ErrorResponse => {
  let error = err.message || 'Something went wrong';
  let message = error;
  let statusCode = 500;
  let data: any;

  try {
    const res = err.response.data;
    error = res.error;
    message = res.message;
    statusCode = res.statusCode;
    data = res.data;
  } catch (e) {
    // take default values
  }

  if (import.meta.env.MODE === 'development') console.error(error);

  return {
    error,
    message,
    statusCode,
    data
  };
};

export default makeError;
